import { render, staticRenderFns } from "./addGfBasicMsg.vue?vue&type=template&id=29799b4d&scoped=true&"
import script from "./addGfBasicMsg.vue?vue&type=script&lang=js&"
export * from "./addGfBasicMsg.vue?vue&type=script&lang=js&"
import style0 from "./addGfBasicMsg.vue?vue&type=style&index=0&id=29799b4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29799b4d",
  null
  
)

export default component.exports